window.PreVendaFiltro = Backbone.Model.extend({

});

window.PreVendasFiltros = Backbone.Collection.extend({
    model: PreVendaFiltro
});